import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';

const serviceLayout = EntityContentLayoutBlueprint.make({
  name: 'service',
  params: {
    filter: entity =>
      entity.kind === 'Component' && entity.spec?.type === 'service',
    loader: () =>
      import('./ServiceEntityLayout').then(m => m.ServiceEntityLayout),
  },
});

export const entityLayoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [serviceLayout],
});
